/* eslint-disable prefer-destructuring */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/prefer-default-export */
import { FmdGood, NearMe } from "@mui/icons-material";

import { Chip, CircularProgress, Icon, Switch, IconButton, Tooltip } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { getLabel } from "helpers/dictionary";
import { replaceInTextHbr } from "helpers/utilities";
import i18n from "i18n";
import { t } from "i18next";
import lod_ from "lodash";

/**
 * Display attachment in line (name + href to attachment)
 * @param {[object]} array - Array of attachments
 * @returns {JSX.Element} - JSX.Element
 */
const attachmentRender = array => {
	return (
		<MDBox>
			{array.map((item, index) => {
				return (
					<>
						<MDTypography
							key={index}
							component="a"
							href={item.url}
							target="_blank"
							variant="caption"
							color="info"
							onClick={e => e.stopPropagation()}
							className="defaultdatatable-cell-link"
						>
							{item.name}
						</MDTypography>
						{index < array.length - 1 && <MDBox sx={{ mb: 1 }} />}
					</>
				);
			})}
		</MDBox>
	);
};

const ColorItemLabel = ({ color }) => {
	return (
		<div
			style={{
				height: "3vh",
				width: "3vh",
				borderRadius: "7px",
				backgroundColor: color
			}}
		></div>
	);
};

const createObjectLevel = (obj, lap = 1) => {
	let keys = Object.keys(obj);

	const getValue = value => {
		try {
			return value.toString();
		} catch (e) {
			return value;
		}
	};

	return (
		<div>
			{keys.map((key, index) => {
				let valueType = typeof obj[key];
				if (valueType === "object") {
					return (
						<MDBox key={index}>
							<MDBox key={index}>
								<MDTypography variant="caption" fontWeight="bold">
									{`${key}:`}
								</MDTypography>
							</MDBox>
							{createObjectLevel(obj[key] ?? {})}
						</MDBox>
					);
				} else {
					return (
						<MDBox sx={{ ml: lap }} key={index}>
							<MDTypography variant="caption" fontWeight="bold">
								{`└ ${key}:`}
							</MDTypography>
							<MDTypography sx={{ ml: 1 }} variant="caption">
								{getValue(obj[key])}
							</MDTypography>
						</MDBox>
					);
				}
			})}
		</div>
	);
};

const createObjectTable = (obj, cell, dictionary, form) => {
	if (!lod_.isArray(obj)) {
		obj = [obj];
	}

	let sample = obj[0];
	let keys = Object.keys(sample);

	// Special object cases
	if (sample?.type === "attachment") {
		return attachmentRender(obj);
	}

	// Default display all

	const getValue = value => {
		try {
			return value.toString();
		} catch (e) {
			return value;
		}
	};

	const getDictionryItem = key => {
		let collection = form?.collectionDefault;
		let attribute = cell?.column?.id;

		if (!collection || !attribute) return null;

		let midPath = collection + "." + attribute;

		let realPath = midPath + "." + key;
		realPath = realPath.split(".")?.join(".items.");
		let dictionaryItem = lod_.get(dictionary, realPath);

		return dictionaryItem;
	};

	return (
		<div>
			{keys.map((key, index) => {
				let dictionaryItem = getDictionryItem(key);

				let valueType = typeof sample[key];
				if (valueType === "object") {
					return (
						<MDBox key={index}>
							<MDBox key={index}>
								<MDTypography variant="caption" fontWeight="bold">
									{`${dictionaryItem?.label?.fr ?? key}:`}
								</MDTypography>
							</MDBox>
							{createObjectLevel(sample[key] ?? {})}
						</MDBox>
					);
				} else {
					return (
						<MDBox key={index}>
							<MDTypography variant="caption" fontWeight="bold">
								{`${key}:`}
							</MDTypography>
							<MDTypography sx={{ ml: 1 }} variant="caption">
								{getValue(sample[key])}
							</MDTypography>
						</MDBox>
					);
				}
			})}
		</div>
	);
};

const createArrayTable = arr => {
	return <div>{arr.join(", ")}</div>;
};

/**
 * ##############################
 * Display special fields in table
 * e.g : colors, icons, images, etc
 * ##############################
 */
export function handleSpecialCell(
	cell,
	rowKey,
	dictionary,
	form,
	chart,
	displayDictionaryName = null,
	extra
) {
	let dictionaryPath = (displayDictionaryName ?? chart?.request?.collection) + "." + cell.column.id;
	dictionaryPath = dictionaryPath.replaceAll(".", ".items.");
	dictionaryPath = dictionaryPath.replace(/\[\d+\]/g, "");

	let dictionaryItem = lod_.get(dictionary, dictionaryPath);

	const TYPE_DATE = ["date", "datetime"];
	const TYPE_DURATION = ["timestamp"];
	const TYPE_IMAGES = ["imageList"];
	const TYPE_CODE = ["code"];

	let filtersLabel = [];

	switch (cell.column.id) {
		case "logoURL": {
			const url = cell.value;
			return (
				<MDBox
					component="img"
					src={url}
					alt={url}
					style={{
						width: "30px",
						height: "30px",
						// borderRadius: "50%",
						objectFit: "contain"
					}}
				/>
			);
		}
		case "data.header.sendingDate":
			return <span>{new Date(cell.value).toLocaleString("FR-fr")}</span>;
		case "filters":
			cell.value.map((filter, index) => {
				let realPath = filter.dictionaryPath?.split(".")?.join(".items.");
				let fromDictionary = lod_.get(dictionary, realPath);
				if (fromDictionary && fromDictionary.analytics && fromDictionary.active) {
					filtersLabel.push(fromDictionary.label.fr);
				}
			});
			return <div>{filtersLabel.join(" / ")}</div>;

		case "labels":
			return (
				<MDBox>
					{!lod_.isEmpty(cell.value) ? (
						<>
							{Object.keys(cell.value).map((childItem, key) => {
								return (
									<div style={{ display: "flex" }}>
										<span style={{ fontWeight: "bolder" }}>{childItem} </span>
										<span>{" : " + cell.value[childItem]}</span>
									</div>
								);
							})}
						</>
					) : (
						<MDBox></MDBox>
					)}
				</MDBox>
			);

		case "color":
			return <ColorItemLabel color={cell.value} />;
		case "display.pages":
			return <div>{cell.value.join(", ")}</div>;
		case "images":
			if (!cell.value) return null;
			return <div>voir (bientot dispo)</div>;
		case "createdDate":
			return <span>{new Date(cell.value).toLocaleString("FR-fr")}</span>;
		case "active":
		case "analysed":
		case "configured":
			if (!cell.value) {
				return (
					<Icon color="error" fontSize="medium">
						close
					</Icon>
				);
			} else {
				return (
					<Icon color="success" fontSize="medium">
						check
					</Icon>
				);
			}
		default:
			/**
			 * Collections
			 */
			if (cell.column.id === "state" && form?.collectionDefault === "acknowledgmentOfReceipt") {
				switch (cell.value) {
					case "pending":
						return (
							<Tooltip placement="top" title="En attente">
								<Icon fontSize="medium">hourglass_empty</Icon>
							</Tooltip>
						);
					case "sending":
						return (
							<Tooltip placement="top" title="En cours d'envoi">
								<Icon fontSize="medium">schedule_send</Icon>
							</Tooltip>
						);
					case "sent":
						return (
							<Tooltip placement="top" title="Envoyé">
								<Icon fontSize="medium">check</Icon>
							</Tooltip>
						);
					case "error":
						return (
							<Tooltip placement="top" title="En erreur">
								<Icon fontSize="medium">error</Icon>
							</Tooltip>
						);
					case "canceled":
						return (
							<Tooltip placement="top" title="Annulé">
								<Icon fontSize="medium">cancel</Icon>
							</Tooltip>
						);
					default:
						return cell.render("Cell");
				}
			}
			/**
			 * Dictionary case handling
			 */
			if (dictionaryItem && TYPE_DATE.includes(dictionaryItem.type)) {
				return <span>{new Date(cell.value).toLocaleString("FR-fr")}</span>;
			}
			if (!lod_.isNil(cell?.value) && typeof cell.value === "boolean") {
				return <Switch checked={cell.value} />;
			}

			if (dictionaryItem && TYPE_IMAGES.includes(dictionaryItem.type)) {
				return (
					<MDBox
						component="img"
						src={cell.value}
						style={{
							height: "3rem",
							width: "3rem",
							objectFit: "contain"
						}}
					/>
				);
			}

			if (dictionaryItem && TYPE_CODE.includes(dictionaryItem.type)) {
				let element = dictionaryItem.codes.find(code => code.value === cell.value);
				let label = element ? element.label : cell.value;
				return <span>{label}</span>;
			}
			/**
			 * Collection
			 */
			switch (chart?.request?.collection) {
				case "channel": {
					const values = cell.row.original ?? {};
					let possibleMessage = values.statusMessage;
					let message = null;

					const openEditDialogOnStep = extra?.openEditDialogOnStep ?? (() => {});

					if (possibleMessage) {
						if (i18n.exists(`CHANNEL.ERRORS.${possibleMessage}`)) {
							message = t(`CHANNEL.ERRORS.${possibleMessage}`);
						} else {
							message = possibleMessage;
						}
					}

					switch (cell.column.id) {
						case "status": {
							switch (cell.value) {
								case "testing":
									return (
										<Chip
											label={t("CHANNEL.STATUS.testing")}
											size="small"
											color="info"
											variant="outlined"
											icon={
												<CircularProgress
													size={17}
													sx={{
														padding: "1px",
														color: "info.focus"
													}}
												/>
											}
										/>
									);
								case "error":
								case "errored":
									return (
										<Tooltip placement="top" title={message}>
											<Chip
												label={t("CHANNEL.STATUS.badConfiguration")}
												size="small"
												color="error"
												variant="outlined"
												onClick={() => openEditDialogOnStep(values.code, "CONFIG_PART")}
												icon={<Icon fontSize="medium">cancel</Icon>}
											/>
										</Tooltip>
									);
								/**
								 * Operational case, check if we have other errors
								 */
								case "operational": {
									const original = cell.row.original;
									// Token
									const tokenInfos = original?.tokenStatus;

									const status = tokenInfos?.status;
									const expirationTS = tokenInfos?.expiration;
									const expirationDays = Math.floor(expirationTS / (1000 * 60 * 60 * 24));
									switch (status) {
										case "warning":
											return (
												<Tooltip
													placement="top"
													title={t("CHANNEL.STATUS.TOKEN.warnRenewTokenAlert")}
												>
													<Chip
														label={t("CHANNEL.STATUS.TOKEN.expirationInLabel", {
															days: expirationDays
														})}
														size="small"
														color="warning"
														variant="outlined"
														onClick={() => openEditDialogOnStep(values.code, "CONFIG_PART")}
														icon={<Icon fontSize="medium">warning</Icon>}
													/>
												</Tooltip>
											);
										case "error":
											return (
												<Tooltip
													placement="top"
													title={t("CHANNEL.STATUS.TOKEN.errorRenewTokenAlert")}
												>
													<Chip
														label={t("CHANNEL.STATUS.TOKEN.expirationInLabel", {
															days: expirationDays
														})}
														size="small"
														color="error"
														variant="outlined"
														onClick={() => openEditDialogOnStep(values.code, "CONFIG_PART")}
														icon={<Icon fontSize="medium">error</Icon>}
													/>
												</Tooltip>
											);
										case "expired":
											return (
												<Tooltip
													placement="top"
													title={t("CHANNEL.STATUS.TOKEN.errorRenewTokenAlert")}
												>
													<Chip
														label={t("CHANNEL.STATUS.TOKEN.expired")}
														size="small"
														color="error"
														variant="outlined"
														onClick={() => openEditDialogOnStep(values.code, "CONFIG_PART")}
														icon={<Icon fontSize="medium">dangerous</Icon>}
													/>
												</Tooltip>
											);
										default:
											break;
									}

									/**
									 * Default: Everything is fine
									 */
									return (
										<Chip
											label={t("CHANNEL.STATUS.good")}
											size="small"
											color="success"
											variant="outlined"
											icon={<Icon fontSize="medium">done</Icon>}
										/>
									);
								}
								default: {
									const testChannelConfig = extra?.testChannelConfig ?? (() => {});
									return (
										<Chip
											label={t("CHANNEL.STATUS.checkConfiguration")}
											size="small"
											color="info"
											variant="filled"
											onClick={() => testChannelConfig(values)}
											icon={<Icon fontSize="medium">sync</Icon>}
										/>
									);
								}
							}
						}
						default:
							break;
					}
					break;
				}
				case "answerItem": {
					switch (cell.column.id) {
						case "channelsCode": {
							let channels = [
								{
									code: "ALL",
									name: t("COMPONENT.ANSWERTYPE.allChannels"),
									description: t("COMPONENT.ANSWERTYPE.allChannels"),
									icon: "message"
								},
								...extra.channels
							];
							if (!channels) {
								break;
							}

							let mappedChannels = [];

							(cell.value || []).map(channelCode => {
								let channel = channels.find(channel => channel.code === channelCode);
								if (channel) {
									mappedChannels.push(channel);
								}
							});

							return (
								<MDBox display="flex" alignItems="center" flexDirection="row">
									{mappedChannels.map((channel, index) => {
										return (
											<Tooltip title={channel.name} placement="top" key={index}>
												<MDBox display="flex" alignItems="center" m={1}>
													{channel.logoURL && (
														<MDBox
															component="img"
															src={channel.logoURL}
															alt={channel.name}
															style={{
																width: "30px",
																height: "30px",
																// borderRadius: "50%",
																objectFit: "contain"
															}}
														/>
													)}
													{channel.icon && (
														<Icon
															fontSize="medium"
															sx={{
																width: "30px",
																height: "30px"
															}}
														>
															{channel.icon}
														</Icon>
													)}
												</MDBox>
											</Tooltip>
										);
									})}
								</MDBox>
							);
						}
						case "publishDate": {
							if (cell.value) {
								const date = new Date(cell.value);
								const formattedDate = date
									.toLocaleString("fr-FR", {
										year: "numeric",
										month: "2-digit",
										day: "2-digit",
										hour: "2-digit",
										minute: "2-digit",
										hour12: false
									})
									.replace(",", "");
								return <span>{formattedDate}</span>;
							}
							return <span>-</span>;
						}
						case "categories":
							if (!cell.value) return null;
							return (
								<MDBox sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
									{cell.value.map((category, index) => (
										<Chip
											key={index}
											label={typeof category === "string" ? category : category.name}
											sx={{
												backgroundColor: typeof category === "string" ? "#e0e0e0" : category.color,
												color: typeof category === "string" ? "#000" : "#fff",
												borderRadius: "4px",
												fontSize: "0.75rem"
											}}
										/>
									))}
								</MDBox>
							);
						default:
							break;
					}
					break;
				}
				case "messageStat": {
					switch (cell.column.id) {
						case "topicHasBeenUpdated": {
							const topicHasBeenUpdated = cell.row?.original?.topicHasBeenUpdated ?? false;
							if (topicHasBeenUpdated) {
								return (
									<Tooltip placement="top" title={t("INTENTS.intentUpdatedWithFeedback")}>
										<Icon fontSize="medium">rate_review</Icon>
									</Tooltip>
								);
							} else {
								return null;
							}
						}
						case "topic": {
							const topics = extra?.topics || [];
							const language = extra?.language;
							const topic = topics.find(t => t.code === cell.value);
							const label = topic ? getLabel(topic.label, language) : cell.value;
							return label;
						}
						case "fID": {
							return (
								<Tooltip placement="top" title={t("SETTINGS.seeConversation")}>
									<IconButton
										onClick={e => {
											e.stopPropagation();
											e.preventDefault();

											const urlTemplate = extra?.urlTemplate;
											const assistantID = extra?.assistantID;

											if (lod_.isNil(urlTemplate)) {
												return;
											}

											const url = replaceInTextHbr(urlTemplate, {
												fID: cell.value,
												assistantID
											});
											window.open(url, "_blank");
										}}
									>
										<Icon>visibility</Icon>
									</IconButton>
								</Tooltip>
							);
						}
						default:
							break;
					}
					break;
				}
				default:
					break;
			}

			/**
			 * Dictionary case handling
			 */
			if (dictionaryItem && TYPE_DATE.includes(dictionaryItem.type)) {
				return <span>{new Date(cell.value).toLocaleString("FR-fr")}</span>;
			}
			if (!lod_.isNil(cell?.value) && typeof cell.value === "boolean") {
				if (!cell.value) {
					return (
						<Icon color="error" fontSize="medium">
							close
						</Icon>
					);
				} else {
					return (
						<Icon color="success" fontSize="medium">
							check
						</Icon>
					);
				}
			}

			if (dictionaryItem && TYPE_IMAGES.includes(dictionaryItem.type)) {
				return (
					<MDBox
						component="img"
						src={cell.value}
						style={{
							height: "3rem",
							width: "3rem",
							objectFit: "contain"
						}}
					/>
				);
			}

			/**
			 * Default case handling
			 */
			if (cell.column.id === "examples" || cell.column.id === "predictions") {
				if (lod_.isArray(cell.value)) {
					return cell.value.length;
				} else if (lod_.isNil(cell.value)) {
					return "0";
				}
			}

			if (lod_.isArray(cell.value)) {
				let sample = cell.value[0];

				if (lod_.isObject(sample)) {
					return createObjectTable(cell.value, cell, dictionary, form);
				} else {
					return createArrayTable(cell.value);
				}
			} else if (lod_.isObject(cell.value) && !lod_.isNil(cell.value)) {
				return createObjectTable(cell.value, cell, dictionary, form);
			} else {
				return !lod_.isNil(cell.value)
					? cell.render("Cell")
					: lod_.get(cell.row.original, cell.column.id.split("."));
			}
	}
}
